export function filterNonEmptyArrays(input) {
  var result = {};
  for (var key in input) {
    var _input$key;
    if (((_input$key = input[key]) === null || _input$key === void 0 ? void 0 : _input$key.length) > 0) {
      result[key] = input === null || input === void 0 ? void 0 : input[key];
    }
  }
  return result;
}